var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCtaButtonArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 37,
    viewBox: "0 0 27 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.468676 36.403C0.594402 36.4663 0.732989 36.5 0.87444 36.5C1.05017 36.5 1.22304 36.4466 1.36736 36.3481L26.6228 19.2195C26.8586 19.0592 27 18.7962 27 18.5136C27 18.2323 26.8586 17.9679 26.6228 17.8076L1.36736 0.650929C1.09876 0.469516 0.750157 0.44983 0.461543 0.601708C0.17437 0.752182 -0.00420406 1.04891 7.52299e-05 1.37094V35.6436C7.52299e-05 35.9629 0.180094 36.2554 0.468676 36.4031V36.403Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCtaButtonArrow);
export default __webpack_public_path__ + "static/media/ctaButtonArrow.a090dec894ec247dd1f0f7e2454ac90b.svg";
export { ForwardRef as ReactComponent };